import { useEffect } from 'react'
import { useAuthToken } from 'hooks/use-auth-token'
import { CodeAuthorization } from 'pages/CodeAuthorization'
import { setSentryUser } from 'utils'
import { useDoesPaypassNeedCodeAuthenticationQuery } from 'generated/graphql'
import { OnboardingWrapper } from 'pages/Onboarding/OnboardingWrapper'

export const App = () => {
  const token = useAuthToken()

  useEffect(() => {
    setSentryUser(token)
  }, [token])

  const { data: authData, loading: authLoading } =
    useDoesPaypassNeedCodeAuthenticationQuery()

  const needsCodeAuth =
    authData?.doesPaypassNeedCodeAuthentication?.isCodeAuthenticationNeeded

  if (authLoading) {
    return null
  }

  if (needsCodeAuth) {
    return <CodeAuthorization />
  }

  return <OnboardingWrapper />
}
